import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/IBMa/ibm.com-able-v2/able-site/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { withPrefix } from "gatsby";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h4>{`Level 1`}</h4>
    <ul>
      <li parentName="ul"><a href={withPrefix("toolkit/develop/keyboard/#interactive-elements")} target="_blank" rel="noopener noreferrer">Ensure interactive elements are reachable with the keyboard</a></li>
      <li parentName="ul"><a href={withPrefix("toolkit/develop/keyboard/#tab-order")} target="_blank" rel="noopener noreferrer">Where possible, achieve the desired tab order by adjusting the DOM, rather than overriding the tabindex</a></li>
    </ul>
    <h4>{`Level 2`}</h4>
    <ul>
      <li parentName="ul">{`No level 2 developer tasks for this requirement`}</li>
    </ul>
    <h4>{`Level 3`}</h4>
    <ul>
      <li parentName="ul">{`No level 3 developer tasks for this requirement`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      